<div class="ir-item-line th-filter th-filter--expand">
  <div
    (click)="setOrderBy(inspectionOrderField.ByStartDate)"
    [ngClass]="{ fullwidth: inspectionOrderField.ByStartDate === extendedColumn }"
    class="ir-item-cell size-custom size-custom--startdate clickable active"
  >
    <ng-container *ngTemplateOutlet="sortIcons"></ng-container>
    <span>
      {{ 'inspections.start-date' | translate }}
    </span>
    <ng-container *ngTemplateOutlet="expandIcons; context: { $implicit: inspectionOrderField.ByStartDate }">
    </ng-container>
  </div>
  <div
    (click)="setOrderBy(inspectionOrderField.ByCustomer)"
    [ngClass]="{ fullwidth: inspectionOrderField.ByCustomer === extendedColumn }"
    class="ir-item-cell size-custom size-custom--customer clickable"
  >
    <ng-container *ngTemplateOutlet="sortIcons"></ng-container>
    <span>
      {{ 'inspections.customer' | translate }}
    </span>
    <ng-container *ngTemplateOutlet="expandIcons; context: { $implicit: inspectionOrderField.ByCustomer }">
    </ng-container>
  </div>
  <div
    (click)="setOrderBy(inspectionOrderField.ByEquipmentType)"
    [ngClass]="{ fullwidth: inspectionOrderField.ByEquipmentType === extendedColumn }"
    class="ir-item-cell size-custom size-custom--equipment clickable"
  >
    <ng-container *ngTemplateOutlet="sortIcons"></ng-container>
    <span>
      {{ 'inspections.equipement-type' | translate }}
    </span>
    <ng-container *ngTemplateOutlet="expandIcons; context: { $implicit: inspectionOrderField.ByEquipmentType }">
    </ng-container>
  </div>
  <div
    (click)="setOrderBy(inspectionOrderField.ByEquipmentNumber)"
    [ngClass]="{ fullwidth: inspectionOrderField.ByEquipmentNumber === extendedColumn }"
    class="ir-item-cell size-custom size-custom--equipment-number clickable"
  >
    <ng-container *ngTemplateOutlet="sortIcons"></ng-container>
    <span> {{ 'inspections.equipement' | translate }} # </span>
    <ng-container *ngTemplateOutlet="expandIcons; context: { $implicit: inspectionOrderField.ByEquipmentNumber }">
    </ng-container>
  </div>
  <div
    (click)="setOrderBy(inspectionOrderField.ByFST)"
    [ngClass]="{ fullwidth: inspectionOrderField.ByFST === extendedColumn }"
    class="ir-item-cell size-custom size-custom--fst clickable"
  >
    <ng-container *ngTemplateOutlet="sortIcons"></ng-container>
    <span>
      {{ 'inspections.fst' | translate }}
    </span>
    <ng-container *ngTemplateOutlet="expandIcons; context: { $implicit: inspectionOrderField.ByFST }"></ng-container>
  </div>
  <div
    (click)="setOrderBy(inspectionOrderField.ByProgress)"
    [ngClass]="{ fullwidth: inspectionOrderField.ByProgress === extendedColumn }"
    class="ir-item-cell size-custom size-custom--progression clickable right"
  >
    <ng-container *ngTemplateOutlet="sortIcons"></ng-container>
    <span>
      {{ 'inspections.progression' | translate }}
    </span>
    <ng-container *ngTemplateOutlet="expandIcons; context: { $implicit: inspectionOrderField.ByProgress }">
    </ng-container>
  </div>
  <div
    (click)="setOrderBy(inspectionOrderField.ByStatus)"
    [ngClass]="{ fullwidth: inspectionOrderField.ByStatus === extendedColumn }"
    class="ir-item-cell size-custom size-custom--status clickable right"
  >
    <ng-container *ngTemplateOutlet="sortIcons"></ng-container>
    <span>
      {{ 'common.status' | translate }}
    </span>
    <ng-container *ngTemplateOutlet="expandIcons; context: { $implicit: inspectionOrderField.ByStatus }"></ng-container>
  </div>
  <ng-template #sortIcons>
    <ng-container>
      <i class="material-icons" *ngIf="orderBy < 0">arrow_drop_up</i>
      <i class="material-icons" *ngIf="orderBy >= 0">arrow_drop_down</i>
    </ng-container>
  </ng-template>
  <ng-template #expandIcons let-column>
    <i class="material-icons" (click)="extend($event, column)" *ngIf="column === extendedColumn; else unfoldMore"
      >unfold_less</i
    >
    <ng-template #unfoldMore><i class="material-icons" (click)="extend($event, column)">unfold_more</i></ng-template>
  </ng-template>
</div>
<div class="ir-content-flow has-filter" (scroll)="scroll($event)">
  <div
    class="ir-item-line th-inspection clickable"
    [ngClass]="{
      'offline-not-loaded': (!inspection?.lastSyncDate && !isConnection) || inspection?.status === -50,
      'new-inspection': inspection?.isNew
    }"
    (click)="selectInspection(inspection)"
    *ngFor="let inspection of inspections"
  >
    <div
      class="ir-item-cell size-custom size-custom--startdate"
      [ngClass]="{ fullwidth: inspectionOrderField.ByStartDate === extendedColumn }"
    >
      <span>{{ inspection?.startDate | formatDate }}</span>
    </div>
    <div
      class="ir-item-cell size-custom size-custom--customer"
      [ngClass]="{ fullwidth: inspectionOrderField.ByCustomer === extendedColumn }"
    >
      <span>{{ inspection?.customerName ?? inspection?.name }}</span>
    </div>
    <div
      class="ir-item-cell size-custom size-custom--equipment important"
      [ngClass]="{ fullwidth: inspectionOrderField.ByEquipmentType === extendedColumn }"
    >
      <span [title]="inspection?.equipementType">{{ inspection?.equipementType }}</span>
    </div>
    <div
      class="ir-item-cell size-custom size-custom--equipment-number"
      [ngClass]="{ fullwidth: inspectionOrderField.ByEquipmentNumber === extendedColumn }"
    >
      <span [title]="inspection?.serial">{{ inspection?.serial }}</span>
    </div>
    <div
      class="ir-item-cell size-custom size-custom--fst"
      [ngClass]="{ fullwidth: inspectionOrderField.ByFST === extendedColumn }"
    >
      <span>{{ inspection?.technicianName }}</span>
    </div>
    <div
      class="ir-item-cell size-custom size-custom--progression right strong statut"
      [ngClass]="{ fullwidth: inspectionOrderField.ByProgress === extendedColumn }"
    >
      <i *ngIf="inspection?.isOffline && !inspection?.updatedOffline" class="material-icons list-icon offline"
        >offline_pin</i
      >
      <i *ngIf="inspection?.isOffline && inspection?.updatedOffline" class="material-icons list-icon warning"
        >offline_pin</i
      >
      <i *ngIf="!inspection?.isOffline && inspection?.lastSyncDate && !isConnection" class="material-icons list-icon"
        >visibility</i
      >
      <i *ngIf="!inspection?.isOffline && inspection?.isSynchronizing" class="material-icons list-icon offline">sync</i>
      <span>{{ inspection?.progression }} %</span>
    </div>

    <div
      class="ir-item-cell size-custom size-custom--status right strong statut"
      [ngClass]="{ fullwidth: inspectionOrderField.ByStatus === extendedColumn }"
    >
      <i *ngIf="inspection.reportItemId" (click)="openReport(inspection, $event)" class="material-icons list-icon"
        >picture_as_pdf</i
      >
      <span>{{ inspection?.status | inspectionstatus }}</span>
    </div>
  </div>

  <div class="ir-item-empty ir-mv8" *ngIf="inspections?.length == 0">
    <p>
      <span>{{ 'inspections.no-inspections' | translate }}</span>
    </p>
  </div>
</div>
<!-- End content flow -->
